const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");

const OfficeModal = require("../office/modals/OfficeModal");
const LoadingCircle = require("../core/view/LoadingCircle");
const CopyTable = require("./data/CopyTable");
const ClassesUtil = require("./util/ClassesUtil");
const OpsSchool = require("./vault/OpsSchool");

const styles = require("./styles/ConfirmModal.css");

module.exports = createReactClass({
	displayName: "SchoolConfirmModal",

	propTypes: {
		// type can be: deactivate|activate|remove, with scope props (classID, schoolID, userID), and enabled Bool
		typeProps: PT.object.isRequired,
		onConfirm: PT.func,
		status: PT.string,
		onClose: PT.func,
		schoolState: PT.object,
		error: PT.string,
	},

	handleClick: function() {
		this.props.onConfirm(this.props.typeProps);
	},

	render: function() {
		const {
			typeProps,
			status,
			onConfirm,
			onClose,
			schoolState,
			error,
		} = this.props;
		const isSingleSchool = _.get(
			schoolState,
			"accounts.purchase.isSingleSchool"
		);
		const {schoolID, classID, userID, role} = typeProps;
		let errorMoreInfo;
		let targetName, targetScopeName;
		let isLastTeacher = false;
		const isStaff = OpsSchool.isStaff(schoolState, userID);

		if (userID) {
			targetName = ClassesUtil.getUserName(
				OpsSchool.getUser(schoolState, userID)
			);
			if (role && schoolID) {
				targetScopeName = _.get(schoolState, [
					"accounts",
					"schools",
					schoolID,
					"displayName",
				]);
			} else if (role && classID) {
				targetScopeName = _.get(schoolState, [
					"accounts",
					"classes",
					classID,
					"displayName",
				]);
				const teachersForClass = OpsSchool.getTeachersForClass(
					schoolState,
					classID
				);
				if (teachersForClass.length === 1) {
					isLastTeacher = true;
				}
			}
			errorMoreInfo = isStaff ? "staff" : "student";
		} else if (schoolID) {
			targetName = _.get(schoolState, [
				"accounts",
				"schools",
				schoolID,
				"displayName",
			]);
		} else if (classID) {
			targetName = _.get(schoolState, [
				"accounts",
				"classes",
				classID,
				"displayName",
			]);
		}

		const chooseCopy = CopyTable.getConfirmModalCopy(
			styles,
			_.extend(
				{
					targetName,
					targetScopeName,
					isStaff,
					isLastTeacher,
					isSingleSchool,
				},
				typeProps
			)
		);
		let actionButton;
		let cancelButton;
		const buttonClass =
			typeProps.type === "activate" ? styles.button : styles.redButton;
		if (!status) {
			actionButton = (
				<div className={buttonClass} onClick={() => onConfirm(typeProps)}>
					{chooseCopy.button}
				</div>
			);
			cancelButton = (
				<div className={styles.button} onClick={onClose}>
					Cancel
				</div>
			);
		} else if (status === "pending") {
			actionButton = (
				<div className={buttonClass}>
					<div className={styles.loading}>
						<LoadingCircle colorType="white" />
					</div>
				</div>
			);
		} else if (status === "success" || status === "error") {
			cancelButton = (
				<div className={styles.button} onClick={onClose}>
					Okay
				</div>
			);
		}

		let message = chooseCopy.main;
		if (status === "error") {
			message = (
				<div className={styles.message}>
					{CopyTable.getErrorCopy(error, "activate", errorMoreInfo)}
				</div>
			);
		}

		return (
			<OfficeModal
				onClose={onClose}
				closeOnEsc={true}
				portalContainer={null}
				level="overBar"
				modalClass={styles.main}
			>
				<div className={styles.container}>
					<div className={styles.title}>{chooseCopy.title}</div>
					{message}
					<div className={styles.buttonRow}>
						{actionButton}
						{cancelButton}
					</div>
				</div>
			</OfficeModal>
		);
	},
});
